import React from 'react';
import classNames from 'classnames';
import './ViewSwitcher.scss';
import SvgIcon from '@home/components/SvgIcon';

interface IViewSwitcherProps {
  value: 'card' | 'table';
  onChange: (value: 'card' | 'table') => void;
  className?: string;
}

/**
 * Card / Table 视图切换（按 Figma 3902_52397 设计实现）
 *
 * 两个独立 36×36 白底带边框按钮，选中态边框/图标变蓝
 */
export default function ViewSwitcher({
  value,
  onChange,
  className,
}: IViewSwitcherProps) {
  return (
    <div className={classNames('dbom-ct-view-switcher', className)}>
      <span
        className={classNames('dbom-ct-view-switcher__btn', {
          '--active': value === 'card',
        })}
        onClick={() => onChange('card')}
      >
        <SvgIcon type={'card'} className='dbom-ct-view-switcher__icon' />
      </span>
      <span
        className={classNames('dbom-ct-view-switcher__btn', {
          '--active': value === 'table',
        })}
        onClick={() => onChange('table')}
      >
        <SvgIcon type={'sheet'} className='dbom-ct-view-switcher__icon' />
      </span>
    </div>
  );
}
